export const isValueExist = (v) => v !== null && v !== undefined && v !== '-'

export const formatValue = (v, d = 2) => {
  if (!isValueExist(v)) {
    return '-'
  }

  if (!d) {
    return new Intl.NumberFormat('en-EN', {
      maximumFractionDigits: 0,
    }).format(v)
  }

  return new Intl.NumberFormat('en-EN', {
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  }).format(v)
}

export const formatZeroValueToPercent = (v, d = 2) =>
  isValueExist(v) && v > 0
    ? `${new Intl.NumberFormat('en-EN', {
        minimumFractionDigits: d,
        maximumFractionDigits: d,
      }).format(v * 100)}`
    : '-'

export const columnsToHide = (storedColConfig, getAccountID, accountInfoData) => {
  const obj = {}

  if (storedColConfig[getAccountID()]) {
    storedColConfig[getAccountID()].forEach((item) => {
      if (item.key === 'error' && !accountInfoData?.additionalColumns?.includes('errors')) {
        obj[item.key] = false
        return
      }

      if (item.key === 'activeCount' && !accountInfoData?.additionalColumns?.includes('activeProducts')) {
        return
      }
      // Always available on front
      // if (item.key === 'averageOrganicRank' && !accountInfoData?.additionalColumns?.includes('averageOrganicRank')) {
      //   obj[item.key] = false
      //   return
      // }

      obj[item.key] = item.value
    })
  } else {
    storedColConfig?.default?.forEach((item) => {
      if (item.key === 'error' && !accountInfoData?.additionalColumns?.includes('errors')) {
        obj[item.key] = false
        return
      }

      if (item.key === 'activeCount' && !accountInfoData?.additionalColumns?.includes('activeProducts')) {
        return
      }
      // Always available on front
      // if (item.key === 'averageOrganicRank' && !accountInfoData?.additionalColumns?.includes('averageOrganicRank')) {
      //   obj[item.key] = false
      //   return
      // }

      obj[item.key] = item.value
    })
  }

  return obj
}
